import React from 'react';
type LogoVariant = 'olive' | 'black';
const COLORS: Record<LogoVariant, string> = {
  olive: '#4A4B2F',
  black: '#111111'
};
interface MarkProps {
  color?: string;
  className?: string;
}
/**
 * GuitarCrossMark — single-line acoustic guitar whose neck forms a subtle
 * Christian cross, with one string continuing past the body into a gentle
 * forward arrow (the journey continues).
 */
export function GuitarCrossMark({
  color = COLORS.olive,
  className = ''
}: MarkProps) {
  return <svg viewBox="0 0 80 72" className={className} fill="none" stroke={color} strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" role="img" aria-label="Kitara" data-id="element-78">
      {/* Guitar tilted as if being played — avoids any upright 'standing stone' read */}
      <g transform="rotate(-24 34 40)" data-id="element-79">
        {/* Body (single continuous line) */}
        <path d="M30,36 C21,36 17,44 19,50 C20,55 15,58 16,63 C17,69 27,68 30,68 C33,68 43,69 44,63 C45,58 40,55 41,50 C43,44 39,36 30,36 Z" data-id="element-80" />
        {/* Sound hole */}
        <circle cx="30" cy="52" r="3.2" data-id="element-81" />
        {/* Neck */}
        <path d="M30,36 L30,12" data-id="element-82" />
        {/* A single subtle fret crossing the neck — quiet nod to faith, not a standing cross */}
        <path d="M25,21 L35,21" data-id="element-83" />
      </g>
      {/* One string carries on past the guitar into a gentle forward arrow */}
      <path d="M50,40 C60,42 66,39 73,38" data-id="element-84" />
      <path d="M68,34.5 L73,38 L68,41.5" data-id="element-85" />
    </svg>;
}
interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  /** icon-only, no text */
  iconOnly?: boolean;
}
export function Logo({
  variant = 'olive',
  className = '',
  iconOnly = false
}: LogoProps) {
  const color = COLORS[variant];
  if (iconOnly) {
    return <GuitarCrossMark color={color} className={className} data-id="element-86" />;
  }
  return <div className={`flex items-center gap-3 ${className}`} data-id="element-87">
      <GuitarCrossMark color={color} className="h-10 w-10 flex-shrink-0" data-id="element-88" />
      <span className="font-serif font-semibold tracking-wide text-2xl" style={{
      color
    }} data-id="element-89">
        DANI 70
      </span>
    </div>;
}